import http from '@/shared/api/http'

function query(params = {}) {
  const result = {}
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') result[key] = value
  })
  return result
}

export async function getImportJobs(params) {
  return (await http.get('/import-jobs', { params: query(params) })).data
}

export async function createImportJob(payload) {
  return (await http.post('/import-jobs', payload)).data
}

export async function deleteImportJob(jobId) {
  return (await http.delete(`/import-jobs/${jobId}`)).data
}

export async function getImportJob(jobId) {
  return (await http.get(`/import-jobs/${jobId}`)).data
}

export async function getImportOrchestration(jobId) {
  return (await http.get(`/import-jobs/${jobId}/orchestration`)).data
}

export async function uploadImportSource(jobId, file) {
  const form = new FormData()
  form.append('file', file, file.name)
  return (await http.post(`/import-jobs/${jobId}/source-files`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000
  })).data
}

export async function queueImportParsing(jobId) {
  return (await http.post(`/import-jobs/${jobId}/queue-parsing`)).data
}

export async function getParseStructure(jobId) {
  return (await http.get(`/import-jobs/${jobId}/parse-structure`)).data
}

export async function getParsePreview(jobId, documentId, sheetId, maxRows = 100) {
  return (await http.get(`/import-jobs/${jobId}/parse-preview`, {
    params: { documentId, sheetId, maxRows },
    timeout: 30000
  })).data
}

export async function getColumnMapping(jobId, sourceFileId, sheetOrder = 0, params = {}) {
  return (await http.get(`/import-jobs/${jobId}/source-files/${sourceFileId}/normalized-sheets/${sheetOrder}/column-mapping`, {
    params: query(params), timeout: 60000
  })).data
}

export async function validateColumnMapping(jobId, sourceFileId, sheetOrder, payload, params = {}) {
  return (await http.post(`/import-jobs/${jobId}/source-files/${sourceFileId}/normalized-sheets/${sheetOrder}/column-mapping/validate`, payload, {
    params: query(params), timeout: 60000
  })).data
}

export async function confirmColumnMapping(jobId, sourceFileId, sheetOrder, payload, params = {}) {
  return (await http.post(`/import-jobs/${jobId}/source-files/${sourceFileId}/normalized-sheets/${sheetOrder}/column-mapping/confirm`, payload, {
    params: query(params), timeout: 60000
  })).data
}

export async function getConfirmedColumnMapping(jobId, sourceFileId, sheetOrder, params = {}) {
  return (await http.get(`/import-jobs/${jobId}/source-files/${sourceFileId}/normalized-sheets/${sheetOrder}/column-mapping/confirmed`, {
    params: query(params), timeout: 60000
  })).data
}

export async function getMappedImportRows(jobId, sourceFileId, sheetOrder, params = {}) {
  return (await http.get(`/import-jobs/${jobId}/source-files/${sourceFileId}/normalized-sheets/${sheetOrder}/column-mapping/mapped-rows`, {
    params: query(params), timeout: 60000
  })).data
}
